import computeCruiseTotals from './computeCruiseTotals';
import computeTripSegmentAmounts from './computeTripSegmentAmounts';
import computeHotelCommissionMeta from './computeHotelCommissionMeta';

// Amounts are analytics-only enrichment — never let them break the success flow.
// Shared by the direct booking saga and the booking-status polling saga so both
// completion paths emit the same event shape.
const buildBookingSuccessAmounts = ({ trip, priceBreakdowns, passengers, bookingResponses }) => {
  try {
    const cruiseTotals = computeCruiseTotals({
      trip,
      priceBreakdowns,
      passengers,
      bookingResponses,
    });

    return {
      ...computeTripSegmentAmounts({ trip, cruiseTotals }),
      ...computeHotelCommissionMeta(trip),
      totalDueNowAmount: cruiseTotals?.totalDueNowAmount,
      // Cruise trip whose price-breakdown lookup missed: cruise-derived values
      // are unknowable here — flag it so silent lookup failures are observable.
      cruiseTotalsUnavailable: trip?.cruiseItinerary && !cruiseTotals ? true : undefined,
    };
  } catch (amountsError) {
    console.error(amountsError);
    return {};
  }
};

export default buildBookingSuccessAmounts;
